import { RiderTypeCode } from '@app/domain/model/eshop/transport/RiderTypeCode';
import { AppParameters } from '@app/infrastructure/parameters/model/AppParameters';

export function getReadMoreUrl(typeCode: string, appParameters: AppParameters): string {
    const urlMap: Record<string, string> = {
        [RiderTypeCode.HelpOnRoadPlus]: appParameters.eshopInfoUrls.mtplRoadAssistancePremium,
        [RiderTypeCode.ExtendedHelpOnRoad]: appParameters.eshopInfoUrls.mtplRoadAssistanceBasic,
        [RiderTypeCode.TechnicalAssistance]: appParameters.eshopInfoUrls.techAssistance,
        [RiderTypeCode.DriverPassengerLiability]: appParameters.eshopInfoUrls.cascoAdditionalCoverage,
    };

    return urlMap[typeCode] || '#';
}
